/* CREALIS — cuenta regresiva de la oferta personalizada del carrito.
   Custom element (no <script> inline): el drawer del carrito se inserta
   vía morph/innerHTML, y los <script> inyectados así nunca se ejecutan en
   el navegador — connectedCallback de un custom element sí se dispara
   siempre, sin importar cómo llegó al DOM. Ver crealis-cart-oferta.liquid. */
class CrOfertaReloj extends HTMLElement {
  connectedCallback() {
    if (this.dataset.listo) return;
    this.dataset.listo = '1';

    const card = this.closest('.cr-cof');
    const duracionMin = 12;
    const tsGuardado = parseInt(this.dataset.ts, 10);

    const iniciar = (ts) => {
      const fin = ts + duracionMin * 60 * 1000;
      const tick = () => {
        const restanteMs = fin - Date.now();
        if (restanteMs <= 0) {
          if (card) card.style.display = 'none';
          clearInterval(this._intervalo);
          return;
        }
        const min = Math.floor(restanteMs / 60000);
        const seg = Math.floor((restanteMs % 60000) / 1000);
        this.textContent = min + ':' + (seg < 10 ? '0' : '') + seg;
      };
      tick();
      this._intervalo = setInterval(tick, 1000);
    };

    if (tsGuardado) {
      iniciar(tsGuardado);
    } else {
      const ahora = Date.now();
      iniciar(ahora);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { cr_oferta_ts: String(ahora) } }),
      }).catch(() => {});
    }
  }

  disconnectedCallback() {
    clearInterval(this._intervalo);
  }
}

if (!customElements.get('cr-oferta-reloj')) {
  customElements.define('cr-oferta-reloj', CrOfertaReloj);
}
